import { z } from "@brains/utils/zod";
import { type MessageResponse, messageResponseSchema } from "./base-types";

export type HandlerResponse = MessageResponse;

const handlerResponseSchema: z.ZodUnion<
  readonly [
    z.ZodObject<{ noop: z.ZodLiteral<true> }>,
    typeof messageResponseSchema,
  ]
> = z.union([z.object({ noop: z.literal(true) }), messageResponseSchema]);

/**
 * Validate unknown handler output before the bus converts it to an internal
 * response.
 */
export function parseHandlerResponse(result: unknown): HandlerResponse {
  const parsed = handlerResponseSchema.safeParse(result);
  if (!parsed.success) {
    throw new Error("Invalid message response format");
  }

  return parsed.data;
}
